const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getUptimeTimeline(orgId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.from) params.append('from', filters.from);
  if (filters.to) params.append('to', filters.to);
  if (filters.siteId) params.append('siteId', filters.siteId);
  if (filters.assetId) params.append('assetId', filters.assetId);
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/uptime/timeline${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to view uptime data');
    }
    throw new Error('Failed to fetch uptime timeline');
  }
  
  return response.json();
}

export async function getUptimeSummary(orgId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.from) params.append('from', filters.from);
  if (filters.to) params.append('to', filters.to);
  if (filters.siteId) params.append('siteId', filters.siteId);
  if (filters.assetId) params.append('assetId', filters.assetId);
  if (filters.programId) params.append('programId', filters.programId);
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/uptime/summary${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch uptime summary');
  }
  
  return response.json();
}
